import {DomainObject, oneOf} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class TypePolicyConfirmationSummary extends DomainObject {
  nextExpectedAccrualDate;
  policyStartDate;
  accrualStart;
  effectiveDateRequired;

  _relations = {
    _dates: ['nextExpectedAccrualDate', 'policyStartDate'],
    accrualStart: oneOf(['policy_start_date', 'policy_holder_start_date'])
  };

  constructor(other) {
    super();

    makeObservable(this, {
      nextExpectedAccrualDate: observable,
      policyStartDate: observable,
      accrualStart: observable,
      effectiveDateRequired: observable
    });

    this.merge(other);
  }
}

export default TypePolicyConfirmationSummary;
